"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IsMobile = require("ismobilejs");
require("./ScrollButton.css");
var ScrollButton = /** @class */ (function (_super) {
    __extends(ScrollButton, _super);
    function ScrollButton(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            intervalId: 0,
            isDisplayed: false,
            isMobile: false,
            isDisabled: false
        };
        _this._scrollStep = _this._scrollStep.bind(_this);
        _this._scrollToTop = _this._scrollToTop.bind(_this);
        _this._stopScroll = _this._stopScroll.bind(_this);
        _this._setIsDisplayed = _this._setIsDisplayed.bind(_this);
        _this._addEventListeners = _this._addEventListeners.bind(_this);
        _this._removeEventListeners = _this._removeEventListeners.bind(_this);
        return _this;
    }
    ScrollButton.prototype.componentDidMount = function () {
        if (!IsMobile.any) {
            window.addEventListener('scroll', throttle(this._setIsDisplayed, 100));
        }
    };
    ScrollButton.prototype.componentWillUnmount = function () {
        this._stopScroll();
    };
    /* istanbul ignore next */
    ScrollButton.prototype._setIsDisplayed = function () {
        if (window.pageYOffset >= 50 && !this.state.isDisplayed) {
            this.setState({ isDisplayed: true });
        }
        if (window.pageYOffset <= 50 && this.state.isDisplayed) {
            this.setState({ isDisplayed: false });
        }
    };
    ScrollButton.prototype._stopScroll = function () {
        clearInterval(this.state.intervalId);
        this._removeEventListeners();
        this.setState({ isDisabled: false });
        window.location.href = '#';
    };
    /* istanbul ignore next */
    ScrollButton.prototype._scrollStep = function () {
        if (window.pageYOffset <= 0) {
            this._stopScroll();
        }
        window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    };
    ScrollButton.prototype._scrollToTop = function () {
        if (this.state.isDisabled) {
            this._stopScroll();
        }
        else {
            this.setState({
                intervalId: window.setInterval(this._scrollStep, this.props.delayInMs),
                isDisabled: true
            });
            // Re-queue the event listeners to end of queue so
            // that it doesn't override scroll to top click
            window.setTimeout(this._addEventListeners, 0);
        }
    };
    /* istanbul ignore next */
    ScrollButton.prototype._addEventListeners = function () {
        window.addEventListener('mousewheel', this._stopScroll);
        window.addEventListener('click', this._stopScroll);
        window.addEventListener('keypress', this._stopScroll);
        window.addEventListener('touchstart', this._stopScroll);
    };
    ScrollButton.prototype._removeEventListeners = function () {
        window.removeEventListener('click', this._stopScroll);
        window.removeEventListener('mousewheel', this._stopScroll);
        window.removeEventListener('keypress', this._stopScroll);
        window.removeEventListener('touchstart', this._stopScroll);
    };
    ScrollButton.prototype.render = function () {
        return this.state.isDisplayed ? (React.createElement("button", { "aria-label": this.props.ariaLabel, title: this.props.buttonTitle, className: "p-scroll-button p-bg-grey40 p-br-5x", onClick: this._scrollToTop, tabIndex: 0 },
            React.createElement("span", { className: "p-icon-right-cursor p-t-light" }))) : null;
    };
    return ScrollButton;
}(React.Component));
function throttle(fn, threshhold) {
    if (threshhold === void 0) { threshhold = 250; }
    var last, deferTimer;
    return function () {
        var context = this, now = +new Date, args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = window.setTimeout(function () { last = now; fn.apply(context, args); }, threshhold);
        }
        else {
            last = now;
            fn.apply(context, args);
        }
    };
}
exports.default = ScrollButton;
//# sourceMappingURL=ScrollButton.js.map


//////////////////
// WEBPACK FOOTER
// ../player-scroll-button/build/control/ScrollButton.js
// module id = 397
// module chunks = 0